module.exports = {
  certificates: {
    downloadCertificate: 'Download certificate',
    searchCertificates: 'Search certificates..',
    toCourses: 'To courses',
    youHaveNoCertificates: 'You have no certificates yet. Start a course now!',
  },
  openid: {
    generic_login_error: 'OpenID Connect authentication failed.',
    no_sso_question: 'No Single-Sign-on account?',
    please_wait: 'Please wait a moment while we fetch the login data...',
    use_default_login: 'Use standard login',
  },
  login: {
    forgotpassword: 'Forgot password?',
    login: 'Login',
    mail: 'E-Mail',
    mail_or_username: 'Email / Username',
    reset_password: 'Reset password',
    title: 'Login',
  },
  logout: {
    message: 'You will be logged out...',
  },
  convert: {
    button_convert: 'Convert!',
    description: 'Here you can change your temporary account into a regular one.<br>This makes it easy to play on other devices.',
    title: 'Change account',
    create_full_account: 'Create an account now',
    benefits_title: 'The advantages of an account:',
    benefits1: 'Use on multiple devices: login anywhere with the same user name and simply continue your learning journey',
    benefits2: 'Permanently save learning statistics',
    benefits3: 'Email notification of news, new files, and quiz battle challenges',
    request_failed: 'Unfortunately, your account could not be converted',
  },
  password: {
    button_change_password: 'Change password',
    new_repeat: 'Repeat new password',
    new: 'New password',
    previous: 'Old password',
    success: 'The password has been changed.',
    request_failed: 'Unfortunately, your password could not be changed',
    we_will_send_you_a_new_one: "No problem. We'll send you a new one.",
    set_new_password: 'Save new password',
    fill_all_fields: 'Please fill in all the fields',
    passwords_dont_match: 'The new passwords did not match',
  },
  profile: {
    certificates: 'Certificates',
    max_file_size: 'The maximum image size is %{size}.',
    invalid_avatar: 'This image is invalid',
    warning: 'Warning',
    warning_description: "As soon as you log out, all your data will be lost. Create an account now so that you don't miss out on quiz battles, can save your progress, and take part in competitions and challenges.",
    change_avatar: 'Update profile image',
    upload_new_avatar: 'Upload new profile image',
    avatar_saving: 'Uploading...',
    existing_avatars: 'Default avatars',
    slug: 'App-ID',
  },
  resetpassword: {
    title: 'Reset Password',
    reset_button: 'Request new password',
    mail_sent: "You've got an email!",
    mail_sent_info: 'We just sent an email with a new password to %{email}.',
    didnt_receive_mail_description: 'Please also check your spam folder or request a new password. Contact %{adminEmail} if it still does not work.',
  },
  signup: {
    signup: 'Create account',
    title: 'Sign Up',
    optional: 'Optional',
    create_account: 'Create account',
    start_with_your_account: 'Get started with your learning account now.',
    firstname_description: '',
    lastname_description: '',
    username_description: 'Your user name lets you be identified within the app, for example when completing the quiz challenge.',
    password_description: 'At least 8 characters, upper and lower case, numbers, and symbols.',
    abort: 'Cancel registration',
    confirm_abort: 'Are you sure you want to cancel the registration?',
    voucher_description: 'You will receive the code from the app provider. Use it to unlock the learning content.',
  },
  legal_reconfirmation: {
    decline: 'Decline',
    tos_title: 'Updated Terms of Service',
    privacy_title: 'Updated Privacy Policy',
    tos_description: 'The Terms of Service have been updated for this platform. To continue using the service, please confirm that you have read and agree to the current terms.',
    privacy_description: 'The Privacy Policy has been updated for this platform. To continue using the service, please confirm that you have read and agree to the current terms.',
  },
  tos: {
    title: 'Terms of Service',
    accept: 'Accept terms of use',
  },
  privacy_policy: {
    title: 'Privacy policy',
    accept: 'Accept privacy policy',
  },
  temporary: {
    try_without_account: 'Test the app without an account',
    guest_account: 'Guest account',
    description: 'Take a look at the content without creating an account.',
    try_now: 'Test now',
    notes_title: 'Note on testing the app without an account',
    notes: 'Your data expires as soon as you log out or the browser cache is deleted.\n              With an account, you can save your progress and log in on different devices.',
  },
  activate: {
    activation_successful: 'You have successfully activated your account!',
    activate_your_account: 'Activate your account',
    didnt_receive_mail: "Didn't get the email?",
    mail_sent_info: "We've sent an email to %{email}. Please click on the link in the email to activate your account.",
    didnt_receive_mail_description: 'Please also check your spam folder. Contact %{adminEmail} if it still does not work.',
    go_to_home: 'Back to the homepage',
  },
  slogan: 'We make learning<br>simply easy.',
  words: 'Quick. Fun. Mobile.',
  signup_are_you_new: 'New here?',
  back_to_login: 'Return to login',
  complete: {
    complete_now: 'Complete your account',
    complete_successful: 'Your account is fully activated and you can now access all features!',
    request_failed: 'Unfortunately, your account could not be updated',
  },
  temporary_account: 'Temporary account',
  select_app: {
    next_step: 'Continue to login',
    title: 'App-ID',
    appid_not_found: 'We could not find a login page for the App-ID specified. Please check the spelling.',
    help_please: 'I cannot find my App-ID',
    is_being_set: 'The app is being configured...',
    appid_label: 'App-ID',
    explanation: 'An App-ID was sent to you using your login credentials. Please enter these in order to access the login page.',
    modal_title: 'How do I find my App-ID?',
    modal_explanation: 'The App-ID can be found in your registration confirmation. You can also view the App-ID on your profile using the app’s website.',
  },
  delete_account: {
    title: 'Request account deletion',
    content: 'Do you want to request that your account gets deleted?',
    success: 'Deletion request was sent',
    confirm_deletion: 'Request account deletion',
    request_failed: 'Sending your deletion request failed. Please contact your administrator directly.',
    request_account_deletion: 'Request account deletion',
  },
  new_username: 'Username',
  force_password_reset: {
    title: 'Assign a new password',
    explanation: 'Please enter a new password with which you can log in in the future.',
    info: 'At least 8 characters, upper and lower case, numbers and symbols.',
    send: 'Save',
  },
}
